import type { User } from '../../api/types'

export interface MentionQuery {
  /** Text typed after "@". */
  query: string
  /** Index of the "@" in the value. */
  start: number
}

/** The @mention being typed right before the caret, if any. */
export function findMentionQuery(value: string, caret: number): MentionQuery | null {
  const before = value.slice(0, caret)
  const match = /(^|\s)@([A-Za-z0-9._-]{0,32})$/.exec(before)
  if (!match) return null
  return { query: match[2], start: before.length - match[2].length - 1 }
}

export function matchMentionCandidates(users: User[], query: string, meId: string | null, limit = 8): User[] {
  const q = query.toLowerCase()
  return users
    // Bots are inactive users by design but can be mentioned; a managing system's actor never can.
    .filter((u) => u.id !== meId && (u.kind === 'bot' || (u.isActive && u.kind === 'person')))
    .map((u) => {
      const username = u.username.toLowerCase()
      const name = u.displayName.toLowerCase()
      const score = username.startsWith(q) ? 0 : name.startsWith(q) ? 1 : name.split(/\s+/).some((p) => p.startsWith(q)) ? 2 : username.includes(q) || name.includes(q) ? 3 : -1
      return { u, score }
    })
    .filter((x) => x.score >= 0)
    .sort((a, b) => a.score - b.score || a.u.displayName.localeCompare(b.u.displayName))
    .slice(0, limit)
    .map((x) => x.u)
}

/** Replace the typed "@query" with "@username " and return the new value and caret. */
export function insertMention(value: string, mention: MentionQuery, username: string): { value: string; caret: number } {
  const end = mention.start + 1 + mention.query.length
  const insert = `@${username} `
  const next = value.slice(0, mention.start) + insert + value.slice(end).replace(/^ /, '')
  return { value: next, caret: mention.start + insert.length }
}
